import { Send } from '@mui/icons-material';
import {
	Box,
	CircularProgress,
	IconButton,
	styled,
	TextField,
	Tooltip,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FormValues } from './Widget';

const InputContainer = styled(Box)(({ theme }) => ({}));

interface Props {
	isLoading: boolean;
}

export default function WidgetInput({ isLoading }: Props) {
	const {
		register,
		formState: { errors },
	} = useFormContext<FormValues>();

	return (
		<InputContainer>
			<TextField
				fullWidth
				variant="filled"
				label="Текст"
				inputProps={{
					...register('text', {
						required: 'Пожалуйста, введите текст',
						validate: (value) =>
							value.trim().length > 0 || 'Пожалуйста, введите текст',
						maxLength: {
							value: 300,
							message: 'Длина текста не должна превышать 300 символов',
						},
					}),
				}}
				InputProps={{
					endAdornment: isLoading ? (
						<Box sx={{ display: 'flex', alignItems: 'center', pr: 1 }}>
							<CircularProgress size={30} thickness={4} color="inherit" />
						</Box>
					) : (
						<Tooltip title="Отправить">
							<IconButton type="submit">
								<Send />
							</IconButton>
						</Tooltip>
					),
				}}
				error={Boolean(errors.text)}
				helperText={
					errors.text?.message ??
					'Для того, чтобы поставить ударение на гласную поставьте перед ней "+"'
				}
				disabled={isLoading}
			/>
		</InputContainer>
	);
}
